import { Link } from "react-router-dom";
import { Flame, Mail, Phone, Music2 } from "lucide-react";
import { WHATSAPP_DISPLAY, EMAIL, TIKTOK, WA_DEFAULT_MSG, waLink } from "@/lib/data";
import { useLang } from "@/lib/i18n";

const Footer = () => {
    const { tr } = useLang();
    return (
        <footer className="border-t border-white/10 bg-obsidian-surface" data-testid="site-footer">
            <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 md:py-20 grid grid-cols-1 md:grid-cols-12 gap-10">
                <div className="md:col-span-5">
                    <Link to="/" className="flex items-center gap-2.5">
                        <span className="flex h-9 w-9 items-center justify-center rounded-full bg-terracotta text-white">
                            <Flame className="h-5 w-5" strokeWidth={2.4} />
                        </span>
                        <span className="font-heading font-extrabold text-xl tracking-tight uppercase">
                            Coach <span className="text-terracotta">Roméo</span>
                        </span>
                    </Link>
                    <p className="mt-5 text-sand leading-relaxed max-w-sm">
                        {tr(
                            "Coaching premium en musculation et nutrition qui célèbre la cuisine africaine. Perte de gras durable, force réelle, saveurs intactes.",
                            "Premium bodybuilding and nutrition coaching that celebrates African cuisine. Lasting fat loss, real strength, flavours intact."
                        )}
                    </p>
                </div>
                <div className="md:col-span-3">
                    <p className="text-xs uppercase tracking-[0.25em] text-sand font-medium">Navigation</p>
                    <ul className="mt-5 space-y-3">
                        {[
                            [tr("Programmes", "Programs"), "/programmes", "programmes"],
                            ["Ebook", "/ebook", "ebook"],
                            [tr("Témoignages", "Testimonials"), "/temoignages", "temoignages"],
                            [tr("À propos", "About"), "/a-propos", "a-propos"],
                            ["FAQ", "/faq", "faq"],
                            ["Consultation", "/contact", "consultation"],
                        ].map(([label, to, id]) => (
                            <li key={to}>
                                <Link
                                    to={to}
                                    data-testid={`footer-link-${id}`}
                                    className="text-cream/80 hover:text-terracotta transition-colors duration-300"
                                >
                                    {label}
                                </Link>
                            </li>
                        ))}
                    </ul>
                </div>
                <div className="md:col-span-4">
                    <p className="text-xs uppercase tracking-[0.25em] text-sand font-medium">
                        {tr("Contact direct", "Direct contact")}
                    </p>
                    <div className="mt-5 space-y-4">
                        <a
                            data-testid="footer-whatsapp-link"
                            href={waLink(tr(WA_DEFAULT_MSG))}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="flex items-center gap-3 text-cream/80 hover:text-whatsapp transition-colors duration-300"
                        >
                            <Phone className="h-4 w-4" /> {WHATSAPP_DISPLAY} (WhatsApp)
                        </a>
                        <a
                            data-testid="footer-email-link"
                            href={`mailto:${EMAIL}`}
                            className="flex items-center gap-3 text-cream/80 hover:text-ochre transition-colors duration-300"
                        >
                            <Mail className="h-4 w-4" /> {EMAIL}
                        </a>
                        <a
                            data-testid="footer-tiktok-link"
                            href={TIKTOK.url}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="flex items-center gap-3 text-cream/80 hover:text-ochre transition-colors duration-300"
                        >
                            <Music2 className="h-4 w-4" /> TikTok {TIKTOK.handle}
                        </a>
                    </div>
                </div>
            </div>
            <div className="border-t border-white/10 py-6 text-center text-xs text-sand tracking-wider">
                © {new Date().getFullYear()} Coach Roméo — {tr("Tous droits réservés.", "All rights reserved.")}
            </div>
        </footer>
    );
};

export default Footer;
